import { ReactNode } from 'react';

import { TranslatableText, useTranslate } from '@dreryk/react-common';

type HistoricalVisitsListItemHeaderProps = {
   readonly text: TranslatableText;
   readonly icon?: JSX.Element;
   readonly children?: ReactNode;
};

export const HistoricalVisitsListItemHeader = (props: HistoricalVisitsListItemHeaderProps): JSX.Element => {
   const translate = useTranslate();
   return (
      <>
         <span>{translate(props.text)}</span>
         {props.children}
         {props.icon}
      </>
   );
};
